import React, { createContext, useContext, useEffect, useRef } from 'react';
import { useAuth } from '../auth/index';
import { useNotifications } from '../notifications/index';

const WebSocketContext = createContext();
export const useWebSocketContext = () => useContext(WebSocketContext);

export const WebSocketProvider = ({ children }) => {
  const { token } = useAuth();
  const { handleWebSocketMessage } = useNotifications();
  const wsRef = useRef(null);

  useEffect(() => {
    if (!token) return;

    const wsUrl = `wss://backendportalproveedores.tasa.com.pe/ws?token=${token}`;

    const ws = new WebSocket(wsUrl);
    wsRef.current = ws;

    ws.onopen = () => {
    };

    ws.onerror = (error) => {
      console.error('❌ WebSocket error:', error);
    };

    ws.onclose = () => {
    };
    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        handleWebSocketMessage(data);
      } catch (error) {
        console.error('Error parsing message:', error);
      }
    };

    return () => {
      ws.close();
    };
  }, [token, handleWebSocketMessage]);

  return (
    <WebSocketContext.Provider value={{ isConnected: wsRef.current?.readyState === WebSocket.OPEN }}>
      {children}
    </WebSocketContext.Provider>
  );
};